(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phonemax-localization"] && !Shopify.designMode) return;
  try {
    function pmLocalizeAnonymousReviews(root) {
  root.querySelectorAll('.jm-reviewer-info__name, .jdgm-rev__author').forEach((author) => {
    if (author.textContent.trim() !== '匿名') return;
    author.textContent = 'Anonymous';
    if (author.hasAttribute('title')) author.setAttribute('title', 'Anonymous');
  });
  root.querySelectorAll('.jm-reviewer-avatar__initial span, .jdgm-rev__icon').forEach((icon) => {
    if (icon.textContent.trim() === '匿') icon.textContent = 'A';
  });
  root.querySelectorAll('[class*="jm-"][aria-label], .jdgm-widget [aria-label], .jdgm-widget [alt]').forEach((element) => {
    ['alt', 'aria-label'].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (value?.includes('匿名')) element.setAttribute(attribute, value.replaceAll('匿名', 'Anonymous'));
    });
  });
}
function pmWatchReviewLanguage() {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  pmLocalizeAnonymousReviews(document);
  new MutationObserver(() => pmLocalizeAnonymousReviews(document)).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label', 'title', 'alt']
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', pmWatchReviewLanguage, { once: true });
} else {
  pmWatchReviewLanguage();
}
  } catch(e) { console.error(e); }
})();

})();
